import axios from "axios";
import React from "react";
import { GetErrorMessage } from "../functions/error";
import { useError } from "./ErrorModal";

export const TagsContex = React.createContext<{
  tagsStorages: string[];
  setTagsStorages: (data: string[]) => void;
}>({
  tagsStorages: [],
  setTagsStorages: (_: string[]) => {},
});

interface Props {
  children?: JSX.Element;
}

export default function TagsStoreProvider(props: Props) {
  const [tagsStorages, setTagsStorages] = React.useState<string[]>([]);
  const { onError } = useError();
  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("/tags/");
        const tags = res.data as string[];
        setTagsStorages(tags);
      } catch (error) {
        onError(GetErrorMessage(error));
      }
    };
    fetchData();
  }, [onError]);
  return (
    <TagsContex.Provider value={{ tagsStorages, setTagsStorages }}>
      {props.children}
    </TagsContex.Provider>
  );
}

export const useTags = () => React.useContext(TagsContex);
